import type { CommunitiesDropdown } from 'modules/dashboard/components/Groups/types'
import groups from 'modules/dashboard/store/collections/communities/Groups'
import type Group from 'modules/dashboard/store/models/communities/Group'

type Params = { communitiesDropdown: CommunitiesDropdown; group?: Group }

export const useCanCreatePosts = ({ communitiesDropdown, group }: Params) => {
  const groupToCheck =
    group ??
    (communitiesDropdown.strategy === 'group'
      ? groups.find((g) => g.id === communitiesDropdown.value)
      : undefined)

  if (groupToCheck) {
    return groupToCheck.policy.can('addPostsPosts')
  }

  return groups.some((groupToFilter) => groupToFilter.policy.can('addPostsPosts'))
}
